<template>
  <div>
    <base-header
      type="gradient-warning"
      class="pb-6 pb-8 pt-5 pt-md-8 opacity-8"
    >
    </base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-8 col-8 mb-1">
            <button
              v-on:click="onEditRow"
              :disabled="!showActionEdit"
              class="btn btn-primary ml-2"
            >
              <i class="fa fa-edit"></i> Details
            </button>
            <download-excel
              :data="selectedItems"
              name="giftaway-selected-transaction.csv"
              type="csv"
              style="float: left"
            >
              <button class="btn btn-primary ml-2">
                <i class="fa fa-download"></i>
                Export selected
              </button>
            </download-excel>
            <download-excel
              :data="rows"
              name="giftaway-transaction.csv"
              type="csv"
              style="float: left"
            >
              <button class="btn btn-primary ml-2">
                <i class="fa fa-download"></i>
                Export all to .csv
              </button>
            </download-excel>
          </div>
        </div>
        <div v-if="message">
          <base-alert :type="message.type" :dismissible="true">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="message.type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
            >{{ row.message }}</base-alert
          >
        </div>
        <div class="accordion p-3" role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button
                block
                v-b-toggle.accordion-1
                variant="neutral"
                class="text-left"
                >Search Transaction Criteria
                <span class="when-opened ml-3">
                  <i class="fa fa-arrow-down" />
                </span>
                <span class="when-closed ml-3">
                  <i class="fa fa-arrow-right" />
                </span>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-1"
              visible
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    brand
                  </label>
                  <div class="col-sm-3">
                    <b-form-select
                      id="input-3"
                      v-model="BrandCodeModel"
                      :options="brandCodeOption"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    transaction date
                  </label>
                  <div class="col-sm-10">
                    <date-picker
                      v-model="timeFilter"
                      range
                      confirm-text="confirm"
                      confirm
                      editable
                      clearable
                      :default-value="timeFilter"
                      value-type="YYYY-MM-DD"
                      @confirm="onDateFilterSubmit"
                      id="DateRange"
                    ></date-picker>
                  </div>
                </div>
                <div class="mb-4 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    query by
                  </label>
                  <div class="col-sm-3">
                    <b-form-select
                      id="input-3"
                      v-model="PropertyFilterModel"
                      :options="PropertyFilterList"
                      required
                    ></b-form-select>
                  </div>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="ConditionFilterModel"
                      :options="ConditionFilterList"
                      :disabled="IsConditionFilterDisabled"
                      required
                    ></b-form-select>
                  </div>
                  <div class="col-sm-4">
                    <input v-model="ValueFilterModel" class="form-control" />
                  </div>
                </div>
                <div class="mt-3 row">
                  <div class="col-sm-2 col-form-label form-control-label"></div>
                  <button
                    v-on:click="onSearchFilter"
                    class="btn btn-warning ml-3"
                  >
                    <i class="fa fa-search"></i> Search
                  </button>
                  <button
                    v-on:click="onResetFilter"
                    class="btn btn-neutral ml-2"
                  >
                    <i class="fa fa-times"></i> reset query
                  </button>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
        >
        </vue-bootstrap4-table>
        <div class="overflow-auto mt-3">
          <nav>
            <ul class="pagination b-pagination justify-content-center">
              <li class="page-item">
                <a
                  class="page-link text-warning"
                  href="javascript:void(0)"
                  v-if="currentPage != 1"
                  v-on:click="onLoadMore(pageNumber - 1)"
                  >prev</a
                >
              </li>
              <li
                class="page-item"
                :class="{ active: currentPage == pageNumber }"
                v-for="pageNumber in ListNextToken.length"
                :key="pageNumber"
              >
                <a
                  class="page-link"
                  href="javascript:void(0)"
                  v-on:click="onLoadMore(pageNumber)"
                  >{{ pageNumber }}</a
                >
              </li>
              <li class="page-item" v-if="!isCompletedLoadAllItems">
                <a class="page-link text-warning" href="javascript:void(0)"
                  >...</a
                >
              </li>
              <li class="page-item">
                <button
                  class="page-link text-warning"
                  v-on:click="onLoadMore(null)"
                  v-if="
                    !isCompletedLoadAllItems ||
                      currentPage != ListNextToken.length
                  "
                >
                  next
                </button>
              </li>
              <li class="col-4">
                <b-form-select
                  class="col-2 ml-2"
                  v-model="itemPerPage"
                  :options="ItemPerPageList"
                  required
                ></b-form-select>
                <label class="ml-2">items per page</label>
              </li>
            </ul>
            <div class="pagination justify-content-center">
              <label>{{ allTransaction.length }} items loaded</label>
              <label class="text-success ml-1" v-if="isCompletedLoadAllItems"
                >- completed load all data</label
              >
            </div>
          </nav>
        </div>
      </div>
    </div>
    <modal :show.sync="showModalCreate" modal-classes="modal-md">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} Redeem Transaction
      </h3>
      <table class="table table-striped">
        <tr>
          <td>Brand</td>
          <td>{{ this.selectedItems[0].brand_code }}</td>
        </tr>
        <tr>
          <td>Product</td>
          <td>{{ this.selectedItems[0].product_id }}</td>
        </tr>
        <tr>
          <td>Catalog</td>
          <td>{{ this.selectedItems[0].catalog_name }}</td>
        </tr>
        <tr>
          <td>Merchant</td>
          <td>{{ this.selectedItems[0].merchant_id }}</td>
        </tr>
        <tr>
          <td>Order No</td>
          <td>{{ this.selectedItems[0].order_id }}</td>
        </tr>
        <tr>
          <td>Reference No</td>
          <td>{{ this.selectedItems[0].reference_no }}</td>
        </tr>
        <tr>
          <td>Win Loss Status</td>
          <td
            class="green"
            v-if="this.selectedItems[0].winloss_status == 'WIN'"
          >
            {{ this.selectedItems[0].winloss_status }}
          </td>
          <td class="red" v-if="this.selectedItems[0].winloss_status == 'LOSS'">
            {{ this.selectedItems[0].winloss_status }}
          </td>
        </tr>
        <tr>
          <td>Reward Status</td>
          <td>{{ this.selectedItems[0].status }}</td>
        </tr>
        <tr>
          <td>Expired Date</td>
          <td>{{ this.selectedItems[0].expiry_date_time }}</td>
        </tr>
        <tr>
          <td>Credit Used</td>
          <td>{{ this.selectedItems[0].credits_used }}</td>
        </tr>
        <tr>
          <td>Credit Balance</td>
          <td>{{ this.selectedItems[0].credits_balance }}</td>
        </tr>
        <tr>
          <td>Amount Deducted</td>
          <td>{{ this.selectedItems[0].deducted_amount }}</td>
        </tr>
        <tr>
          <td>Urls</td>
          <td>{{ this.selectedItems[0].urls }}</td>
        </tr>
        <tr>
          <td>Create Date</td>
          <td>{{ this.selectedItems[0].create_date }}</td>
        </tr>
        <tr>
          <td>Modify Date</td>
          <td>{{ this.selectedItems[0].modify_date }}</td>
        </tr>
      </table>
    </modal>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import { API } from "aws-amplify";
import * as queries from "./../graphql/queries";
import "vue2-datepicker/index.css";

export default {
  name: "configList",
  data() {
    return {
      isCompletedLoadAllItems: false,
      nextToken: null,
      ListNextToken: [],
      itemPerPage: 25,
      ItemPerPageList: [25, 50, 100],
      currentPage: 1,
      IsConditionFilterDisabled: true,
      BrandCodeModel: "PHFortune",
      DateRangeModel: null,
      ValueFilterModel: "",
      PropertyFilterModel: "id",
      ConditionFilterModel: "eq",
      PropertyFilterList: [
        { text: "transaction id", value: "id" },
        { text: "reference no", value: "reference_no" },
        { text: "product name", value: "catalog_name" },
        { text: "reward status", value: "status" },
      ],
      ConditionFilterList: [
        { text: "equals", value: "eq" },
        { text: "contains", value: "contains" },
        { text: "begin with", value: "beginsWith" },
        { text: "not contains", value: "notContains" },
      ],
      showLoadButton: true,
      timeFilter: [],
      filter: null,
      allTransaction: [],
      selectedItems: [],
      showActionEdit: false,
      showActionDelete: false,
      brandCodeOption: [
        { text: "Fortune", value: "PHFortune" },
        { text: "Chesterfield", value: "PHChe" },
      ],
      stockPeriodOption: [
        { text: "Weekly", value: 1 },
        { text: "Monthly", value: 2 },
        { text: "Campaign Period", value: 3 },
      ],
      titlePopup: "Create",
      message: null,
      productModel: {
        id: "",
        brand_code: "",
        product_id: "",
        catalog_name: "",
        merchant_id: "",
        order_id: "",
        reference_no: "",
        winloss_status: "",
        status: "",
        gift_status: "",
        expiry_date_time: "",
        credits_used: "",
        credits_balance: "",
        deducted_amount: "",
        urls: "",
        denomination: "",
        create_date: "",
        modify_date: "",
      },
      showModalCreate: false,
      showModalDetail: false,
      allMerchants: [],
      rows: [],
      columns: [
        {
          label: "ID",
          name: "id",
          row_text_alignment: "text-left",
        },
        {
          label: "Ref No",
          name: "reference_no",
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Win/Loss Status",
          name: "winloss_status",
          sort: true,
        },
        {
          label: "Brand",
          name: "brand_code",
          sort: true,
        },
        {
          label: "Order ID",
          name: "order_id",
          sort: true,
        },
        {
          label: "Voucher/Product Name",
          name: "catalog_name",
          sort: true,
        },
        {
          label: "Denomination",
          name: "denomination",
          sort: true,
        },
        {
          label: "Reward Status",
          name: "status",
          sort: true,
        },
        {
          label: "Date",
          name: "create_date",
          sort: true,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        num_of_visibile_pagination_buttons: 8,
        per_page: this.itemPerPage ? this.itemPerPage : 25,
        checkbox_rows: true,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: true,
        card_mode: false,
        selected_rows_info: true,
        global_search: {
          visibility: false,
        },
        show_refresh_button: false,
        show_reset_button: false,
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function(row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    let momNow = this.$moment(new Date().toUTCString());
    let filterEndDate = momNow.format("YYYY-MM-DD");
    let filterStartDate = momNow.add(-1, "months").format("YYYY-MM-DD");
    this.timeFilter.push(filterStartDate);
    this.timeFilter.push(filterEndDate);
    let momStart = this.$moment(new Date(this.timeFilter[0])).format(
      "YYYY-MM-DD"
    );
    let momEnd = this.$moment(new Date(this.timeFilter[1])).format(
      "YYYY-MM-DD"
    );
    this.DateRangeModel = { between: [momStart, momEnd] };
    this.onLoadData();
    this.selectedItems.push(this.productModel);
  },
  methods: {
    onResetFilter() {
      this.filter = null;
      this.onLoadData();
      this.ValueFilterModel = "";
      this.PropertyFilterModel = "id";
      this.ConditionFilterModel = "contains";
    },
    onSearchFilter() {
      var jsonCondition =
        '{"' + this.ConditionFilterModel + '":"' + this.ValueFilterModel + '"}';
      console.log(jsonCondition);
      var modelCondition = JSON.parse(jsonCondition);
      switch (this.PropertyFilterModel) {
        case "catalog_name":
          this.filter = { catalog_name: modelCondition };
          break;
        case "status":
          this.filter = { status: modelCondition };
          break;
        default:
          break;
      }
      if (this.PropertyFilterModel == "id" && this.ValueFilterModel) {
        this.onSearchByTransID(this.ValueFilterModel);
      } else if (
        this.PropertyFilterModel == "reference_no" &&
        this.ValueFilterModel
      ) {
        this.onSearchByRefNo(this.ValueFilterModel);
      } else {
        this.onLoadData();
      }
    },
    onDateFilterSubmit(value) {
      let momStart = this.$moment(new Date(value[0])).format("YYYY-MM-DD");
      let momEnd = this.$moment(new Date(value[1])).format("YYYY-MM-DD");
      this.DateRangeModel = { between: [momStart, momEnd] };
    },
    async onLoadData() {
      this.ListNextToken = [null];
      try {
        let data = await API.graphql({
          query: queries.listEmsGiftAwayTransactionsByBrandCodeIndex,
          variables: {
            brand_code: this.BrandCodeModel,
            start_date: this.DateRangeModel.between[0],
            end_date: this.DateRangeModel.between[1],
            limit: this.itemPerPage,
            filter: this.filter,
          },
        });
        let nextData =
          data.data.listEmsGiftAwayTransactionsByBrandCodeIndex.items;
        this.rows = nextData;
        this.allTransaction = this.rows;
        this.nextToken =
          data.data.listEmsGiftAwayTransactionsByBrandCodeIndex.nextToken;
        this.isCompletedLoadAllItems = this.nextToken == null ? true : false;
        this.currentPage = 1;
      } catch (error) {
        console.log(error);
      }
    },
    async onSearchByTransID(transaction_id) {
      var result = [];
      try {
        let data = await API.graphql({
          query: queries.getEmsGiftAwayTransaction,
          variables: {
            id: transaction_id,
          },
        });
        result.push(data.data.getEmsGiftAwayTransaction);
        this.rows = result;
        this.allTransaction = this.rows;
        this.isCompletedLoadAllItems = true;
        this.ListNextToken = [null];
        this.currentPage = 1;
      } catch (error) {
        console.log(error);
      }
    },
    async onSearchByRefNo(ref_no) {
      try {
        let data = await API.graphql({
          query: queries.listEmsGiftAwayTransactionsByReferenceNoIndex,
          variables: {
            reference_no: ref_no,
            limit: this.itemPerPage,
          },
        });
        this.rows =
          data.data.listEmsGiftAwayTransactionsByReferenceNoIndex.items;
        this.allTransaction = this.rows;
        this.isCompletedLoadAllItems = true;
        this.ListNextToken = [null];
        this.currentPage = 1;
      } catch (error) {
        console.log(error);
      }
    },
    async onLoadMore(selectedPage) {
      try {
        let currentPageToken = this.nextToken;
        if (selectedPage != null) {
          currentPageToken = this.ListNextToken[selectedPage - 1];
          this.currentPage = selectedPage;
        } else if (
          selectedPage == null &&
          this.currentPage < this.ListNextToken.length
        ) {
          this.currentPage += 1;
          selectedPage = this.currentPage;
          currentPageToken = this.ListNextToken[selectedPage - 1];
        }

        let data = await API.graphql({
          query: queries.listEmsGiftAwayTransactionsByBrandCodeIndex,
          variables: {
            brand_code: this.BrandCodeModel,
            start_date: this.DateRangeModel.between[0],
            end_date: this.DateRangeModel.between[1],
            limit: this.itemPerPage,
            filter: this.filter,
            nextToken: currentPageToken,
          },
        });

        let nextData =
          data.data.listEmsGiftAwayTransactionsByBrandCodeIndex.items;
        for (let index = 0; index < nextData.length; index++) {
          let currentID = nextData[index].id;
          let existedData = this.allTransaction.filter(
            (x) => x.id === currentID
          )[0];
          if (!existedData) {
            this.allTransaction.push(nextData[index]);
          }
        }
        if (currentPageToken && selectedPage == null) {
          this.currentPage += 1;
          this.ListNextToken.push(currentPageToken);
          this.isCompletedLoadAllItems =
            data.data.listEmsGiftAwayTransactionsByBrandCodeIndex.nextToken ==
            null
              ? true
              : false;
          console.log(this.ListNextToken);
        }
        this.rows = nextData;
        this.nextToken =
          data.data.listEmsGiftAwayTransactionsByBrandCodeIndex.nextToken;
      } catch (error) {
        console.log(error);
      }
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      if (payload.selected_items.length == 0) {
        this.showActionEdit = false;
        this.showActionDelete = false;
        this.selectedItems.push(this.productModel);
      }
      if (payload.selected_items.length > 1) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.productModel = this.allTransaction.filter(
        (x) => x.id === this.selectedItems[0].id
      )[0];
      this.showModalCreate = true;
      this.titlePopup = "Details";
    },
  },
  components: {
    VueBootstrap4Table,
  },
  watch: {
    PropertyFilterModel: function(val) {
      if (val == "id" || val == "reference_no") {
        this.ConditionFilterModel = "eq";
        this.IsConditionFilterDisabled = true;
      } else {
        this.ConditionFilterModel = "contains";
        this.IsConditionFilterDisabled = false;
      }
      console.log(val);
    },
    itemPerPage: function() {
      this.config.per_page = this.itemPerPage;
      this.onLoadData();
    },
  },
};
</script>
<style></style>
